export enum DeliveryNoteEndpoint {
  Base = '/automotive-aftermarket',
  Monitoring = '/monitoring',
  DeliveryNote = '/delivery-note',
  Overview = '/overview',
  Notifications = '/notifications',
  HandlingUnits = '/handling-units',
  Parties = '/parties',
  Statuses = '/statuses',
  ProofOfDelivery = '/proof-of-delivery',
  Documents = '/documents',
  Request = '/request',
}
